// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Dashboard de equipos (WorkstationsDashboard).
 *
 * Prefijo \`wsd-\`. Todo el color sale de las variables del tema para que
 * funcione con las skins clara/oscura; los tintes de icono son rgba fijos
 * porque los tokens del proyecto no traen versión translúcida.
 */

.wsd {
  padding: 18px 22px 30px;
  color: var(--text-primary);
}

/* ── Cabecera ─────────────────────────────────────────────────────────────── */

.wsd-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.wsd-head-text {
  min-width: 0;
}

.wsd-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.wsd-title-row h1 {
  margin: 0;
  font-size: 1.45rem;
  line-height: 1.15;
  letter-spacing: -0.01em;
  color: var(--text-primary);
}

.wsd-head p {
  margin: 5px 0 0;
  font-size: 0.84rem;
  color: var(--text-muted);
}

.wsd-demo-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 9px;
  border-radius: 999px;
  background: rgba(245, 158, 11, 0.16);
  border: 1px solid rgba(245, 158, 11, 0.38);
  color: var(--amber-600, #d97706);
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  white-space: nowrap;
}

.wsd-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 15px;
  border-radius: 8px;
  border: 1px solid transparent;
  font-family: inherit;
  font-size: 0.83rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: filter 0.15s, transform 0.15s;
}

.wsd-btn--primary {
  background: var(--accent);
  color: #fff;
}

.wsd-btn--primary:hover {
  filter: brightness(1.08);
  transform: translateY(-1px);
}

.wsd-btn--ghost {
  background: var(--bg-card);
  color: var(--text-secondary, var(--text-muted));
  border-color: var(--border);
}

.wsd-btn--ghost:hover:not(:disabled) {
  border-color: rgb(var(--accent-rgb) / 0.55);
  color: var(--text-primary);
}

.wsd-btn:disabled {
  opacity: 0.6;
  cursor: default;
}

.wsd-updated {
  font-size: 0.68rem;
  color: var(--text-muted);
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid var(--border);
  background: var(--bg-toolbar);
  white-space: nowrap;
}

.is-spinning {
  animation: wsd-spin 1s linear infinite;
}

@keyframes wsd-spin {
  to { transform: rotate(360deg); }
}

.wsd-btn svg {
  width: 16px;
  height: 16px;
  stroke-width: 2;
}

/* ── KPIs ─────────────────────────────────────────────────────────────────── */

.wsd-kpis {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(178px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.wsd-kpi {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 13px 15px 12px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
  text-decoration: none;
  color: inherit;
  min-width: 0;
  transition: border-color 0.15s, box-shadow 0.15s, transform 0.15s;
}

.wsd-kpi:hover {
  border-color: rgb(var(--accent-rgb) / 0.55);
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.12);
  transform: translateY(-1px);
}

.wsd-kpi-top {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.wsd-kpi-icon,
.wsd-panel-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 9px;
}

.wsd-kpi-icon {
  width: 30px;
  height: 30px;
}

.wsd-kpi-icon svg {
  width: 16px;
  height: 16px;
  stroke-width: 1.8;
}

.wsd-kpi-label {
  font-size: 0.73rem;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wsd-kpi-value {
  font-size: 1.7rem;
  font-weight: 700;
  line-height: 1.05;
  letter-spacing: -0.02em;
  color: var(--text-primary);
}

.wsd-kpi-value small {
  margin-left: 2px;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-muted);
}

.wsd-kpi-bar {
  height: 5px;
  border-radius: 3px;
  background: var(--bg-toolbar);
  overflow: hidden;
}

.wsd-kpi-bar span {
  display: block;
  height: 100%;
  border-radius: 3px;
}

.wsd-fill-ok { background: var(--green-600, #16a34a); }
.wsd-fill-warn { background: var(--amber-600, #d97706); }
.wsd-fill-bad { background: var(--red-600, #dc2626); }
.wsd-fill-info { background: var(--accent); }

.wsd-kpi-hint {
  font-size: 0.71rem;
  line-height: 1.35;
  color: var(--text-muted);
}

/* ── Tintes por tono ──────────────────────────────────────────────────────── */

.wsd-tone-ok {
  color: var(--green-600, #16a34a);
  background: rgba(22, 163, 74, 0.12);
}

.wsd-tone-warn {
  color: var(--amber-600, #d97706);
  background: rgba(217, 119, 6, 0.13);
}

.wsd-tone-bad {
  color: var(--red-600, #dc2626);
  background: rgba(220, 38, 38, 0.12);
}

.wsd-tone-info {
  color: var(--accent, #2563eb);
  background: rgb(var(--accent-rgb) / 0.13);
}

/* ── Rejilla y paneles ────────────────────────────────────────────────────── */

.wsd-grid {
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 14px;
}

.wsd-span-4 { grid-column: span 4; }
.wsd-span-6 { grid-column: span 6; }
.wsd-span-8 { grid-column: span 8; }
.wsd-span-12 { grid-column: span 12; }

.wsd-panel {
  display: flex;
  flex-direction: column;
  min-width: 0;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
  overflow: hidden;
}

.wsd-panel-head {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 13px 15px 10px;
  border-bottom: 1px solid var(--border);
}

.wsd-panel-icon {
  width: 30px;
  height: 30px;
  border-radius: 9px;
}

.wsd-panel-icon svg {
  width: 16px;
  height: 16px;
  stroke-width: 1.8;
}

.wsd-panel-titles {
  min-width: 0;
}

.wsd-panel-titles h2 {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.25;
  color: var(--text-primary);
}

.wsd-panel-titles p {
  margin: 2px 0 0;
  font-size: 0.71rem;
  line-height: 1.3;
  color: var(--text-muted);
}

.wsd-panel-action {
  margin-left: auto;
  flex-shrink: 0;
  padding-top: 2px;
}

.wsd-link {
  font-size: 0.74rem;
  font-weight: 600;
  color: var(--accent-l, var(--accent));
  text-decoration: none;
  white-space: nowrap;
}

.wsd-link:hover {
  text-decoration: underline;
}

.wsd-panel-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 13px 15px 15px;
  min-width: 0;
}

/* ── Donut y leyenda ──────────────────────────────────────────────────────── */

.wsd-split {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.wsd-donut {
  position: relative;
  flex-shrink: 0;
}

.wsd-donut svg {
  display: block;
}

.wsd-donut-center {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  text-align: center;
}

.wsd-donut-center strong {
  font-size: 1.28rem;
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.02em;
  color: var(--text-primary);
}

.wsd-donut-center span {
  margin-top: 3px;
  max-width: 92px;
  font-size: 0.6rem;
  line-height: 1.2;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--text-muted);
}

.wsd-legend {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1 1;
  min-width: 150px;
}

.wsd-legend li {
  display: grid;
  grid-template-columns: 8px minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 7px;
  font-size: 0.75rem;
}

.wsd-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.wsd-legend-label {
  color: var(--text-secondary, var(--text-muted));
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wsd-legend-value {
  font-weight: 600;
  color: var(--text-primary);
}

.wsd-legend-pct {
  min-width: 40px;
  text-align: right;
  color: var(--text-muted);
  font-variant-numeric: tabular-nums;
}

/* ── Notas, barras y subbloques ───────────────────────────────────────────── */

.wsd-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 7px 10px;
  border-radius: 8px;
  background: var(--bg-toolbar);
  font-size: 0.72rem;
  line-height: 1.35;
  color: var(--text-muted);
}

.wsd-note svg {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  margin-top: 1px;
  stroke-width: 1.8;
}

.wsd-subblock {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.wsd-subblock-title {
  font-size: 0.61rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.7px;
  color: var(--text-muted);
  margin-bottom: 3px;
}

/* Canales de instalación (MSI / EXE / código) como chips discretos. */
.wsd-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.wsd-chip {
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--bg-toolbar);
  border: 1px solid var(--border);
  font-size: 0.68rem;
  color: var(--text-secondary, var(--text-muted));
  white-space: nowrap;
}

.wsd-chip strong {
  color: var(--text-primary);
  font-variant-numeric: tabular-nums;
}

.wsd-chip.is-muted {
  border-style: dashed;
  color: var(--text-muted);
}

.wsd-subblock-empty {
  font-size: 0.72rem;
  line-height: 1.35;
  color: var(--text-muted);
  padding: 2px 0;
}

.wsd-mini-row--link {
  text-decoration: none;
  color: inherit;
  border-radius: 6px;
  padding-left: 4px;
  padding-right: 4px;
  transition: background 0.12s ease;
}

.wsd-mini-row--link:hover {
  background: var(--bg-toolbar);
}

.wsd-bar-row {
  display: grid;
  grid-template-columns: minmax(84px, 1.5fr) minmax(40px, 1fr) auto auto;
  align-items: center;
  gap: 7px;
  font-size: 0.74rem;
  padding: 2px 0;
  min-width: 0;
}

.wsd-bar-label {
  color: var(--text-secondary, var(--text-muted));
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wsd-bar-track {
  height: 6px;
  border-radius: 3px;
  background: var(--bg-toolbar);
  overflow: hidden;
}

.wsd-bar-track span {
  display: block;
  height: 100%;
  border-radius: 3px;
}

.wsd-bar-value {
  min-width: 28px;
  text-align: right;
  font-weight: 600;
  color: var(--text-primary);
  font-variant-numeric: tabular-nums;
}

.wsd-mini-badge {
  padding: 1px 6px;
  border-radius: 999px;
  font-size: 0.59rem;
  font-weight: 700;
  white-space: nowrap;
}

.wsd-mini-badge.is-warn {
  background: rgba(217, 119, 6, 0.15);
  color: var(--amber-600, #d97706);
}

.wsd-mini-badge.is-bad {
  background: rgba(220, 38, 38, 0.14);
  color: var(--red-600, #dc2626);
}

.wsd-stacked {
  display: flex;
  height: 9px;
  border-radius: 5px;
  overflow: hidden;
  background: var(--bg-toolbar);
}

.wsd-stacked span {
  display: block;
  height: 100%;
}

.wsd-mini-row {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  padding: 5px 0;
  border-top: 1px dashed var(--border);
  font-size: 0.72rem;
}

.wsd-mini-row:first-of-type {
  border-top: none;
}

.wsd-mini-code {
  font-weight: 600;
  color: var(--text-primary);
  white-space: nowrap;
}

.wsd-mini-detail {
  color: var(--text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wsd-mini-time {
  color: var(--text-muted);
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

/* ── Tabla de atención ────────────────────────────────────────────────────── */

.wsd-table-wrap {
  overflow-x: auto;
  margin: -2px -4px 0;
}

.wsd-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.76rem;
}

.wsd-table th {
  padding: 5px 8px;
  text-align: left;
  font-size: 0.62rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: var(--text-muted);
  border-bottom: 1px solid var(--border);
  white-space: nowrap;
}

.wsd-table td {
  padding: 7px 8px;
  border-bottom: 1px solid var(--border);
  vertical-align: middle;
}

.wsd-table tbody tr:last-child td {
  border-bottom: none;
}

.wsd-table tbody tr:hover {
  background: var(--bg-toolbar);
}

.wsd-table-code {
  font-weight: 600;
  color: var(--text-primary);
  white-space: nowrap;
}

.wsd-table-muted {
  color: var(--text-muted);
  white-space: nowrap;
}

.wsd-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.61rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  white-space: nowrap;
}

.wsd-pill.is-critical {
  background: rgba(220, 38, 38, 0.14);
  color: var(--red-600, #dc2626);
}

.wsd-pill.is-warning {
  background: rgba(217, 119, 6, 0.15);
  color: var(--amber-600, #d97706);
}

.wsd-row-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  color: var(--text-muted);
}

.wsd-row-link:hover {
  color: var(--accent-l, var(--accent));
  background: rgb(var(--accent-rgb) / 0.12);
}

.wsd-row-link svg {
  width: 14px;
  height: 14px;
  stroke-width: 2;
}

/* ── Mini tarjetas de inventario ──────────────────────────────────────────── */

.wsd-mini-cards {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 2px;
}

.wsd-mini-card {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 9px 10px;
  border: 1px solid var(--border);
  border-radius: 9px;
  text-decoration: none;
  color: inherit;
  transition: border-color 0.15s;
}

.wsd-mini-card:hover {
  border-color: rgb(var(--accent-rgb) / 0.55);
}

.wsd-mini-card svg {
  width: 15px;
  height: 15px;
  color: var(--accent-l, var(--accent));
  margin-bottom: 2px;
  stroke-width: 1.8;
}

.wsd-mini-card strong {
  font-size: 1.15rem;
  line-height: 1;
  color: var(--text-primary);
}

.wsd-mini-card span {
  font-size: 0.66rem;
  line-height: 1.25;
  color: var(--text-muted);
}

/* ── Pie ──────────────────────────────────────────────────────────────────── */

.wsd-foot {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 14px;
  font-size: 0.71rem;
  color: var(--text-muted);
}

.wsd-foot-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--amber-600, #d97706);
  flex-shrink: 0;
}

/* ── Carga, error y vacío ─────────────────────────────────────────────────── */

.wsd-skeleton {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
}

.wsd-skeleton span {
  display: block;
  height: 128px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: linear-gradient(
    90deg,
    var(--bg-toolbar) 25%,
    var(--bg-card) 37%,
    var(--bg-toolbar) 63%
  );
  background-size: 400% 100%;
  animation: wsd-shimmer 1.3s ease infinite;
}

@keyframes wsd-shimmer {
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}

.wsd-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 46px 20px;
  text-align: center;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
}

.wsd-state > svg {
  width: 34px;
  height: 34px;
  color: var(--text-muted);
  stroke-width: 1.5;
}

.wsd-state.is-error > svg {
  color: var(--red-600, #dc2626);
}

.wsd-state h2 {
  margin: 0;
  font-size: 1.05rem;
  color: var(--text-primary);
}

.wsd-state p {
  margin: 0;
  max-width: 520px;
  font-size: 0.82rem;
  line-height: 1.45;
  color: var(--text-muted);
}

.wsd-table-empty {
  padding: 18px 8px;
  text-align: center;
  color: var(--text-muted);
  font-size: 0.78rem;
}

@media (prefers-reduced-motion: reduce) {
  .wsd-skeleton span,
  .is-spinning {
    animation: none;
  }
}

/* ── Responsive ───────────────────────────────────────────────────────────── */

@media (max-width: 1180px) {
  .wsd-span-4 { grid-column: span 6; }
  .wsd-span-6 { grid-column: span 12; }
  .wsd-span-8 { grid-column: span 12; }
}

@media (max-width: 720px) {
  .wsd {
    padding: 14px 12px 24px;
  }

  .wsd-span-4,
  .wsd-span-6,
  .wsd-span-8,
  .wsd-span-12 {
    grid-column: span 12;
  }

  .wsd-split {
    gap: 12px;
  }

  .wsd-mini-cards {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/WorkstationsDashboard.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,0CAA0C;EAC1C,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,oBAAoB;EACpB,+BAA+B;EAC/B,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,iEAAiE;AACnE;;AAEA;EACE,2CAA2C;EAC3C,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA,eAAe,qCAAqC,EAAE;AACtD,iBAAiB,qCAAqC,EAAE;AACxD,gBAAgB,mCAAmC,EAAE;AACrD,iBAAiB,yBAAyB,EAAE;;AAE5C;EACE,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,gFAAgF;;AAEhF;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,iDAAiD;EACjD,SAAS;AACX;;AAEA,cAAc,mBAAmB,EAAE;AACnC,cAAc,mBAAmB,EAAE;AACnC,cAAc,mBAAmB,EAAE;AACnC,eAAe,oBAAoB,EAAE;;AAErC;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,YAAY;AACd;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mDAAmD;EACnD,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;EAC7B,+BAA+B;EAC/B,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sEAAsE;EACtE,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA,gFAAgF;;AAEhF;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;AAChB;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB;;;;;GAKC;EACD,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA,gFAAgF;;AAEhF;EACE,cAAc,mBAAmB,EAAE;EACnC,cAAc,oBAAoB,EAAE;EACpC,cAAc,oBAAoB,EAAE;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;;;;IAIE,oBAAoB;EACtB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/**\r\n * Dashboard de equipos (WorkstationsDashboard).\r\n *\r\n * Prefijo `wsd-`. Todo el color sale de las variables del tema para que\r\n * funcione con las skins clara/oscura; los tintes de icono son rgba fijos\r\n * porque los tokens del proyecto no traen versión translúcida.\r\n */\r\n\r\n.wsd {\r\n  padding: 18px 22px 30px;\r\n  color: var(--text-primary);\r\n}\r\n\r\n/* ── Cabecera ─────────────────────────────────────────────────────────────── */\r\n\r\n.wsd-head {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.wsd-head-text {\r\n  min-width: 0;\r\n}\r\n\r\n.wsd-title-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.wsd-title-row h1 {\r\n  margin: 0;\r\n  font-size: 1.45rem;\r\n  line-height: 1.15;\r\n  letter-spacing: -0.01em;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.wsd-head p {\r\n  margin: 5px 0 0;\r\n  font-size: 0.84rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.wsd-demo-pill {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 2px 9px;\r\n  border-radius: 999px;\r\n  background: rgba(245, 158, 11, 0.16);\r\n  border: 1px solid rgba(245, 158, 11, 0.38);\r\n  color: var(--amber-600, #d97706);\r\n  font-size: 0.66rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.4px;\r\n  text-transform: uppercase;\r\n  white-space: nowrap;\r\n}\r\n\r\n.wsd-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 9px 15px;\r\n  border-radius: 8px;\r\n  border: 1px solid transparent;\r\n  font-family: inherit;\r\n  font-size: 0.83rem;\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  transition: filter 0.15s, transform 0.15s;\r\n}\r\n\r\n.wsd-btn--primary {\r\n  background: var(--accent);\r\n  color: #fff;\r\n}\r\n\r\n.wsd-btn--primary:hover {\r\n  filter: brightness(1.08);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.wsd-btn--ghost {\r\n  background: var(--bg-card);\r\n  color: var(--text-secondary, var(--text-muted));\r\n  border-color: var(--border);\r\n}\r\n\r\n.wsd-btn--ghost:hover:not(:disabled) {\r\n  border-color: rgb(var(--accent-rgb) / 0.55);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.wsd-btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: default;\r\n}\r\n\r\n.wsd-updated {\r\n  font-size: 0.68rem;\r\n  color: var(--text-muted);\r\n  padding: 2px 8px;\r\n  border-radius: 999px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n  white-space: nowrap;\r\n}\r\n\r\n.is-spinning {\r\n  animation: wsd-spin 1s linear infinite;\r\n}\r\n\r\n@keyframes wsd-spin {\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n.wsd-btn svg {\r\n  width: 16px;\r\n  height: 16px;\r\n  stroke-width: 2;\r\n}\r\n\r\n/* ── KPIs ─────────────────────────────────────────────────────────────────── */\r\n\r\n.wsd-kpis {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(178px, 1fr));\r\n  gap: 12px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.wsd-kpi {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  padding: 13px 15px 12px;\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  text-decoration: none;\r\n  color: inherit;\r\n  min-width: 0;\r\n  transition: border-color 0.15s, box-shadow 0.15s, transform 0.15s;\r\n}\r\n\r\n.wsd-kpi:hover {\r\n  border-color: rgb(var(--accent-rgb) / 0.55);\r\n  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.12);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.wsd-kpi-top {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  min-width: 0;\r\n}\r\n\r\n.wsd-kpi-icon,\r\n.wsd-panel-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n  border-radius: 9px;\r\n}\r\n\r\n.wsd-kpi-icon {\r\n  width: 30px;\r\n  height: 30px;\r\n}\r\n\r\n.wsd-kpi-icon svg {\r\n  width: 16px;\r\n  height: 16px;\r\n  stroke-width: 1.8;\r\n}\r\n\r\n.wsd-kpi-label {\r\n  font-size: 0.73rem;\r\n  font-weight: 600;\r\n  color: var(--text-muted);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.4px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.wsd-kpi-value {\r\n  font-size: 1.7rem;\r\n  font-weight: 700;\r\n  line-height: 1.05;\r\n  letter-spacing: -0.02em;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.wsd-kpi-value small {\r\n  margin-left: 2px;\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.wsd-kpi-bar {\r\n  height: 5px;\r\n  border-radius: 3px;\r\n  background: var(--bg-toolbar);\r\n  overflow: hidden;\r\n}\r\n\r\n.wsd-kpi-bar span {\r\n  display: block;\r\n  height: 100%;\r\n  border-radius: 3px;\r\n}\r\n\r\n.wsd-fill-ok { background: var(--green-600, #16a34a); }\r\n.wsd-fill-warn { background: var(--amber-600, #d97706); }\r\n.wsd-fill-bad { background: var(--red-600, #dc2626); }\r\n.wsd-fill-info { background: var(--accent); }\r\n\r\n.wsd-kpi-hint {\r\n  font-size: 0.71rem;\r\n  line-height: 1.35;\r\n  color: var(--text-muted);\r\n}\r\n\r\n/* ── Tintes por tono ──────────────────────────────────────────────────────── */\r\n\r\n.wsd-tone-ok {\r\n  color: var(--green-600, #16a34a);\r\n  background: rgba(22, 163, 74, 0.12);\r\n}\r\n\r\n.wsd-tone-warn {\r\n  color: var(--amber-600, #d97706);\r\n  background: rgba(217, 119, 6, 0.13);\r\n}\r\n\r\n.wsd-tone-bad {\r\n  color: var(--red-600, #dc2626);\r\n  background: rgba(220, 38, 38, 0.12);\r\n}\r\n\r\n.wsd-tone-info {\r\n  color: var(--accent, #2563eb);\r\n  background: rgb(var(--accent-rgb) / 0.13);\r\n}\r\n\r\n/* ── Rejilla y paneles ────────────────────────────────────────────────────── */\r\n\r\n.wsd-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(12, minmax(0, 1fr));\r\n  gap: 14px;\r\n}\r\n\r\n.wsd-span-4 { grid-column: span 4; }\r\n.wsd-span-6 { grid-column: span 6; }\r\n.wsd-span-8 { grid-column: span 8; }\r\n.wsd-span-12 { grid-column: span 12; }\r\n\r\n.wsd-panel {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n}\r\n\r\n.wsd-panel-head {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 10px;\r\n  padding: 13px 15px 10px;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n.wsd-panel-icon {\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 9px;\r\n}\r\n\r\n.wsd-panel-icon svg {\r\n  width: 16px;\r\n  height: 16px;\r\n  stroke-width: 1.8;\r\n}\r\n\r\n.wsd-panel-titles {\r\n  min-width: 0;\r\n}\r\n\r\n.wsd-panel-titles h2 {\r\n  margin: 0;\r\n  font-size: 0.9rem;\r\n  line-height: 1.25;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.wsd-panel-titles p {\r\n  margin: 2px 0 0;\r\n  font-size: 0.71rem;\r\n  line-height: 1.3;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.wsd-panel-action {\r\n  margin-left: auto;\r\n  flex-shrink: 0;\r\n  padding-top: 2px;\r\n}\r\n\r\n.wsd-link {\r\n  font-size: 0.74rem;\r\n  font-weight: 600;\r\n  color: var(--accent-l, var(--accent));\r\n  text-decoration: none;\r\n  white-space: nowrap;\r\n}\r\n\r\n.wsd-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.wsd-panel-body {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  padding: 13px 15px 15px;\r\n  min-width: 0;\r\n}\r\n\r\n/* ── Donut y leyenda ──────────────────────────────────────────────────────── */\r\n\r\n.wsd-split {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.wsd-donut {\r\n  position: relative;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.wsd-donut svg {\r\n  display: block;\r\n}\r\n\r\n.wsd-donut-center {\r\n  position: absolute;\r\n  inset: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  pointer-events: none;\r\n  text-align: center;\r\n}\r\n\r\n.wsd-donut-center strong {\r\n  font-size: 1.28rem;\r\n  font-weight: 700;\r\n  line-height: 1;\r\n  letter-spacing: -0.02em;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.wsd-donut-center span {\r\n  margin-top: 3px;\r\n  max-width: 92px;\r\n  font-size: 0.6rem;\r\n  line-height: 1.2;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.4px;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.wsd-legend {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n  flex: 1;\r\n  min-width: 150px;\r\n}\r\n\r\n.wsd-legend li {\r\n  display: grid;\r\n  grid-template-columns: 8px minmax(0, 1fr) auto auto;\r\n  align-items: center;\r\n  gap: 7px;\r\n  font-size: 0.75rem;\r\n}\r\n\r\n.wsd-dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n}\r\n\r\n.wsd-legend-label {\r\n  color: var(--text-secondary, var(--text-muted));\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.wsd-legend-value {\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.wsd-legend-pct {\r\n  min-width: 40px;\r\n  text-align: right;\r\n  color: var(--text-muted);\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n/* ── Notas, barras y subbloques ───────────────────────────────────────────── */\r\n\r\n.wsd-note {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 8px;\r\n  padding: 7px 10px;\r\n  border-radius: 8px;\r\n  background: var(--bg-toolbar);\r\n  font-size: 0.72rem;\r\n  line-height: 1.35;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.wsd-note svg {\r\n  width: 14px;\r\n  height: 14px;\r\n  flex-shrink: 0;\r\n  margin-top: 1px;\r\n  stroke-width: 1.8;\r\n}\r\n\r\n.wsd-subblock {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n  min-width: 0;\r\n}\r\n\r\n.wsd-subblock-title {\r\n  font-size: 0.61rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.7px;\r\n  color: var(--text-muted);\r\n  margin-bottom: 3px;\r\n}\r\n\r\n/* Canales de instalación (MSI / EXE / código) como chips discretos. */\r\n.wsd-chips {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 5px;\r\n}\r\n\r\n.wsd-chip {\r\n  display: inline-flex;\r\n  align-items: baseline;\r\n  gap: 4px;\r\n  padding: 2px 8px;\r\n  border-radius: 999px;\r\n  background: var(--bg-toolbar);\r\n  border: 1px solid var(--border);\r\n  font-size: 0.68rem;\r\n  color: var(--text-secondary, var(--text-muted));\r\n  white-space: nowrap;\r\n}\r\n\r\n.wsd-chip strong {\r\n  color: var(--text-primary);\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.wsd-chip.is-muted {\r\n  border-style: dashed;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.wsd-subblock-empty {\r\n  font-size: 0.72rem;\r\n  line-height: 1.35;\r\n  color: var(--text-muted);\r\n  padding: 2px 0;\r\n}\r\n\r\n.wsd-mini-row--link {\r\n  text-decoration: none;\r\n  color: inherit;\r\n  border-radius: 6px;\r\n  padding-left: 4px;\r\n  padding-right: 4px;\r\n  transition: background 0.12s ease;\r\n}\r\n\r\n.wsd-mini-row--link:hover {\r\n  background: var(--bg-toolbar);\r\n}\r\n\r\n.wsd-bar-row {\r\n  display: grid;\r\n  grid-template-columns: minmax(84px, 1.5fr) minmax(40px, 1fr) auto auto;\r\n  align-items: center;\r\n  gap: 7px;\r\n  font-size: 0.74rem;\r\n  padding: 2px 0;\r\n  min-width: 0;\r\n}\r\n\r\n.wsd-bar-label {\r\n  color: var(--text-secondary, var(--text-muted));\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.wsd-bar-track {\r\n  height: 6px;\r\n  border-radius: 3px;\r\n  background: var(--bg-toolbar);\r\n  overflow: hidden;\r\n}\r\n\r\n.wsd-bar-track span {\r\n  display: block;\r\n  height: 100%;\r\n  border-radius: 3px;\r\n}\r\n\r\n.wsd-bar-value {\r\n  min-width: 28px;\r\n  text-align: right;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.wsd-mini-badge {\r\n  padding: 1px 6px;\r\n  border-radius: 999px;\r\n  font-size: 0.59rem;\r\n  font-weight: 700;\r\n  white-space: nowrap;\r\n}\r\n\r\n.wsd-mini-badge.is-warn {\r\n  background: rgba(217, 119, 6, 0.15);\r\n  color: var(--amber-600, #d97706);\r\n}\r\n\r\n.wsd-mini-badge.is-bad {\r\n  background: rgba(220, 38, 38, 0.14);\r\n  color: var(--red-600, #dc2626);\r\n}\r\n\r\n.wsd-stacked {\r\n  display: flex;\r\n  height: 9px;\r\n  border-radius: 5px;\r\n  overflow: hidden;\r\n  background: var(--bg-toolbar);\r\n}\r\n\r\n.wsd-stacked span {\r\n  display: block;\r\n  height: 100%;\r\n}\r\n\r\n.wsd-mini-row {\r\n  display: grid;\r\n  grid-template-columns: auto minmax(0, 1fr) auto;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 5px 0;\r\n  border-top: 1px dashed var(--border);\r\n  font-size: 0.72rem;\r\n}\r\n\r\n.wsd-mini-row:first-of-type {\r\n  border-top: none;\r\n}\r\n\r\n.wsd-mini-code {\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  white-space: nowrap;\r\n}\r\n\r\n.wsd-mini-detail {\r\n  color: var(--text-muted);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.wsd-mini-time {\r\n  color: var(--text-muted);\r\n  white-space: nowrap;\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n/* ── Tabla de atención ────────────────────────────────────────────────────── */\r\n\r\n.wsd-table-wrap {\r\n  overflow-x: auto;\r\n  margin: -2px -4px 0;\r\n}\r\n\r\n.wsd-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 0.76rem;\r\n}\r\n\r\n.wsd-table th {\r\n  padding: 5px 8px;\r\n  text-align: left;\r\n  font-size: 0.62rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.6px;\r\n  color: var(--text-muted);\r\n  border-bottom: 1px solid var(--border);\r\n  white-space: nowrap;\r\n}\r\n\r\n.wsd-table td {\r\n  padding: 7px 8px;\r\n  border-bottom: 1px solid var(--border);\r\n  vertical-align: middle;\r\n}\r\n\r\n.wsd-table tbody tr:last-child td {\r\n  border-bottom: none;\r\n}\r\n\r\n.wsd-table tbody tr:hover {\r\n  background: var(--bg-toolbar);\r\n}\r\n\r\n.wsd-table-code {\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  white-space: nowrap;\r\n}\r\n\r\n.wsd-table-muted {\r\n  color: var(--text-muted);\r\n  white-space: nowrap;\r\n}\r\n\r\n.wsd-pill {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 2px 8px;\r\n  border-radius: 999px;\r\n  font-size: 0.61rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.4px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.wsd-pill.is-critical {\r\n  background: rgba(220, 38, 38, 0.14);\r\n  color: var(--red-600, #dc2626);\r\n}\r\n\r\n.wsd-pill.is-warning {\r\n  background: rgba(217, 119, 6, 0.15);\r\n  color: var(--amber-600, #d97706);\r\n}\r\n\r\n.wsd-row-link {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 22px;\r\n  height: 22px;\r\n  border-radius: 6px;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.wsd-row-link:hover {\r\n  color: var(--accent-l, var(--accent));\r\n  background: rgb(var(--accent-rgb) / 0.12);\r\n}\r\n\r\n.wsd-row-link svg {\r\n  width: 14px;\r\n  height: 14px;\r\n  stroke-width: 2;\r\n}\r\n\r\n/* ── Mini tarjetas de inventario ──────────────────────────────────────────── */\r\n\r\n.wsd-mini-cards {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 8px;\r\n  margin-top: 2px;\r\n}\r\n\r\n.wsd-mini-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n  padding: 9px 10px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 9px;\r\n  text-decoration: none;\r\n  color: inherit;\r\n  transition: border-color 0.15s;\r\n}\r\n\r\n.wsd-mini-card:hover {\r\n  border-color: rgb(var(--accent-rgb) / 0.55);\r\n}\r\n\r\n.wsd-mini-card svg {\r\n  width: 15px;\r\n  height: 15px;\r\n  color: var(--accent-l, var(--accent));\r\n  margin-bottom: 2px;\r\n  stroke-width: 1.8;\r\n}\r\n\r\n.wsd-mini-card strong {\r\n  font-size: 1.15rem;\r\n  line-height: 1;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.wsd-mini-card span {\r\n  font-size: 0.66rem;\r\n  line-height: 1.25;\r\n  color: var(--text-muted);\r\n}\r\n\r\n/* ── Pie ──────────────────────────────────────────────────────────────────── */\r\n\r\n.wsd-foot {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  margin-top: 14px;\r\n  font-size: 0.71rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.wsd-foot-dot {\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 50%;\r\n  background: var(--amber-600, #d97706);\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* ── Carga, error y vacío ─────────────────────────────────────────────────── */\r\n\r\n.wsd-skeleton {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\r\n  gap: 12px;\r\n}\r\n\r\n.wsd-skeleton span {\r\n  display: block;\r\n  height: 128px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  background: linear-gradient(\r\n    90deg,\r\n    var(--bg-toolbar) 25%,\r\n    var(--bg-card) 37%,\r\n    var(--bg-toolbar) 63%\r\n  );\r\n  background-size: 400% 100%;\r\n  animation: wsd-shimmer 1.3s ease infinite;\r\n}\r\n\r\n@keyframes wsd-shimmer {\r\n  0% { background-position: 100% 0; }\r\n  100% { background-position: -100% 0; }\r\n}\r\n\r\n.wsd-state {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 46px 20px;\r\n  text-align: center;\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n}\r\n\r\n.wsd-state > svg {\r\n  width: 34px;\r\n  height: 34px;\r\n  color: var(--text-muted);\r\n  stroke-width: 1.5;\r\n}\r\n\r\n.wsd-state.is-error > svg {\r\n  color: var(--red-600, #dc2626);\r\n}\r\n\r\n.wsd-state h2 {\r\n  margin: 0;\r\n  font-size: 1.05rem;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.wsd-state p {\r\n  margin: 0;\r\n  max-width: 520px;\r\n  font-size: 0.82rem;\r\n  line-height: 1.45;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.wsd-table-empty {\r\n  padding: 18px 8px;\r\n  text-align: center;\r\n  color: var(--text-muted);\r\n  font-size: 0.78rem;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .wsd-skeleton span,\r\n  .is-spinning {\r\n    animation: none;\r\n  }\r\n}\r\n\r\n/* ── Responsive ───────────────────────────────────────────────────────────── */\r\n\r\n@media (max-width: 1180px) {\r\n  .wsd-span-4 { grid-column: span 6; }\r\n  .wsd-span-6 { grid-column: span 12; }\r\n  .wsd-span-8 { grid-column: span 12; }\r\n}\r\n\r\n@media (max-width: 720px) {\r\n  .wsd {\r\n    padding: 14px 12px 24px;\r\n  }\r\n\r\n  .wsd-span-4,\r\n  .wsd-span-6,\r\n  .wsd-span-8,\r\n  .wsd-span-12 {\r\n    grid-column: span 12;\r\n  }\r\n\r\n  .wsd-split {\r\n    gap: 12px;\r\n  }\r\n\r\n  .wsd-mini-cards {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
